var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShareNetwork',{attrs:{"network":"whatsapp","title":_vm.$attrs.title,"url":_vm.$attrs.url}},[_c('img',{staticClass:"mt-1 mx-1",attrs:{"src":require("../../assets/icons/whatsapp.svg"),"width":"40","alt":"Compartilhar no Whatsapp"}})])}
var staticRenderFns = []

export { render, staticRenderFns }